import type { CircuitMetric, ExerciseMetric, ExerciseRepetition, RoundMetric, ScoreMetadata } from "types";

type SourceUnitMetric = ExerciseMetric | ExerciseRepetition | CircuitMetric | RoundMetric | ScoreMetadata;

class MetricHelpers {
  /**
   * @description Resolves the unit a metric value is stored in, abstracting over the
   * exercise/score `unitOfMeasure` field and the circuit `storageUnit` field so that
   * metric formatting makes no exercise-specific assumptions.
   */
  static getSourceUnit(metric?: SourceUnitMetric | null): string | undefined {
    if (!metric) return undefined;
    if ("unitOfMeasure" in metric) return metric.unitOfMeasure;
    if ("storageUnit" in metric) return metric.storageUnit;
    return undefined;
  }
}

export default MetricHelpers;
